import { HttpForm } from "../Support/HttpForm";
import { axios } from "../Support/Axios";
export class Dashboard extends HttpForm {
    app;
    account_metrics = false;
    recent_orders = false;
    account = null;
    currency = null;
    constructor(app) {
        super();
        this.app = app;
        if (this.app) {
            this.currency = 'GBP';
            if (this.app.currencies[0]) {
                this.currency = this.app.currencies[0].iso3;
            }
        }
        if (this.app && this.app.accounts[0].slug) {
            this.account = this.app.accounts[0].slug;
        }
    }
    mount() {
        return Promise.all([
            this.metrics(),
            this.recentOrders()
        ]);
    }
    metrics() {
        const url = '/api/metrics/account?currency=' + this.currency + '&account=' + this.account;
        return axios.get(url)
            .then((response) => this.account_metrics = response.data.data)
            .catch(e => this.setError(e));
    }
    recentOrders() {
        const url = '/api/order?limit=5&currency=' + this.currency + '&account=' + this.account;
        return axios.get(url)
            .then((response) => this.recent_orders = response.data.data)
            .catch(e => this.setError(e));
    }
    selectAccount() {
        this.resetDashboardData();
        return this.mount();
    }
    selectCurrency() {
        this.resetDashboardData();
        return this.mount();
    }
    resetDashboardData() {
        this.account_metrics = false;
        this.recent_orders = false;
    }
    isAdminUser() {
        if (this.app && this.app.auth) {
            return this.app.auth.role === 'admin';
        }
        return false;
    }
}
